import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMembershipsStatusQuery = createQueryHook(
  MembershipsCreatorApiClient.getMembershipsStatus,
  {
    queryKey: ['membershipsStatus'],
  },
)
